import { BrowserRouter, Routes, Route, Navigate, Outlet, useLocation } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

import Home from './pages/auth/home';
import Operations from './pages/auth/operations';
import Confirmemail from './pages/noauth/confirmemail';
import NoAuth from './pages/noauth';
import NoApprovedEmail from './pages/auth/noapprovedemail';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider, useAuth } from './provider/AuthProvider';
import { Loader } from './components/loader';
import OperationsPage from './pages/auth/operationspage';
import OperationsCategory from './pages/auth/operationscategory';
import OperationsTag from './pages/auth/operationstag';
import ForgetPassword from './pages/noauth/forgetpassword';
import RecoveryPassword from './pages/noauth/recoverypassword';
import Footer from './components/footer';
import PrivacyPolicy from './pages/legal/PrivacyPolicy';
import CookiePolicy from './pages/legal/CookiePolicy';
import Settings from './pages/auth/settings';
import NotFoundPage from './pages/errors/404';
import LandingSaveToRich from './pages/noauth/landing';

function ProtectedRoute() {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <Loader />;
  if (!user) return <Navigate to="/login" replace state={{ from: location }} />;
  if (!user.isApprovedEmail && location.pathname !== '/noapprovedemail') {
    return <Navigate to="/noapprovedemail" replace />;
  }
  return <Outlet />;
}

function PublicOnlyRoute() {
  const { user, loading } = useAuth();
  if (loading) return <Loader />;
  if (user) return <Navigate to="/" replace />;
  return <Outlet />;
}

export default function App() {
  const queryClient = new QueryClient();

  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route element={<PublicOnlyRoute />}>
              <Route path="/landing" element={<LandingSaveToRich />} />
              <Route path="/login" element={<NoAuth />} />
              <Route path="/forgetpassword" element={<ForgetPassword />} />
              <Route path="/recoverypassword" element={<RecoveryPassword />} />
              <Route path="/confirmemail" element={<Confirmemail />} />
            </Route>

            <Route element={<ProtectedRoute />}>
              <Route path="/noapprovedemail" element={<NoApprovedEmail />} />
              <Route path="/" element={<Home />} />
              <Route path="/operations" element={<Operations />} />
              <Route path="/operationscategory/:id" element={<OperationsCategory />} />
              <Route path="/operationstag/:id" element={<OperationsTag />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="/incomes" element={<OperationsPage type="income" />} />
              <Route path="/expenses" element={<OperationsPage type="expense" />} />
            </Route>

            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/cookie-policy" element={<CookiePolicy />} />
            <Route path="/404" element={<NotFoundPage />} />
            <Route path="*" element={<Navigate to="/404" replace />} />
          </Routes>
          <Footer />
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={true}
            closeOnClick={false}
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
          />
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  );
}
